import { IDanhSachHoanTotNghiep } from "../../model/response/xet-tot-nghiep/IDanhSachHoanTotNghiep";
import { apiClient } from "../apiClient";

const DANH_SACH_HOAN_TOT_NGHIEP_ENDPOINT = "danh-sach-hoan-tot-nghiep";
export const danhSachHoanTotNghiepApi = {
    GetDaThem: (id_xet_tot_nghiep: number) => apiClient.get(`${DANH_SACH_HOAN_TOT_NGHIEP_ENDPOINT}/${id_xet_tot_nghiep}/da-them`),
    GetChuaThem: (id_xet_tot_nghiep: number) => apiClient.get(`${DANH_SACH_HOAN_TOT_NGHIEP_ENDPOINT}/${id_xet_tot_nghiep}/chua-them`),
    Insert: (data: Partial<IDanhSachHoanTotNghiep>) => apiClient.post(`${DANH_SACH_HOAN_TOT_NGHIEP_ENDPOINT}`, data),
    Delete: (id: number) => apiClient.delete(`${DANH_SACH_HOAN_TOT_NGHIEP_ENDPOINT}/${id}`),
}
